import { render } from "./LikeRecords.vue?vue&type=template&id=2e2404b6"
import script from "./LikeRecords.vue?vue&type=script&lang=js"
export * from "./LikeRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__